import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import { CountBadgeComponent } from '@shared/components/count-badge/count-badge.component';
import { WaterRatingsComponent } from './ratings/water-ratings.component';
import { WaterTestimonialsComponent } from './testimonials/water-testimonials.component';

@Component({
  selector: 'app-water-reviews',
  templateUrl: './water-reviews.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTabsModule, TranslatePipe, CountBadgeComponent, WaterRatingsComponent, WaterTestimonialsComponent],
})
export class WaterReviewsComponent {
  readonly waterId = input.required<number>();
  /** Emits the combined ratings + testimonials count so the parent form can show it as a tab badge. */
  readonly totalCount = output<number>();

  readonly ratingsCount = signal<number | null>(null);
  readonly testimonialsCount = signal<number | null>(null);

  readonly total = computed(() => (this.ratingsCount() ?? 0) + (this.testimonialsCount() ?? 0));

  constructor() {
    effect(() => {
      if (this.ratingsCount() !== null && this.testimonialsCount() !== null) {
        this.totalCount.emit(this.total());
      }
    });
  }
}
